export enum WonType {
    Any = 'any',
    Won = 'won',
    Lost = 'lost'
}
